import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_char_diary, s_char_threads, s_char_threadsteps} from "../_signals/s_char";
import {ICharDiary} from "../_interfaces/ICharDiary";
import {ICharThread} from "../_interfaces/iCharThread";
import {ICharThreadStep} from "../_interfaces/iCharThreadStep";

export const ThreadsGet = (cid: string) => {
    fetch(apiAddress + "/char/threads/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                if (data.hasOwnProperty('result')) {
                    console.log('BEThreads get reponse', data.result);
                    s_char_threads.value = (data.result as ICharThread[])
                }
            }
        )
        .catch((reason => {
            console.log('BEDiary get catch', reason);
        }))
}

export const ThreadCreate = (thread: ICharThread) => {
    fetch(apiAddress + "/char/threads/", createOptions('CREATE', thread))
        .then((res) => res.json())
        .then((data) => console.log('BEThread create reponse', data))
        .catch((reason => console.log('BEThread create catch', reason)))
}

export const ThreadUpdate = (thread: ICharThread) => {
    fetch(apiAddress + "/char/threads/", createOptions('UPDATE', thread))
        .then((res) => res.json())
        .then((data) => console.log('BEThread update repsonse', data))
        .catch((reason => console.log('BEThread update catch', reason)))
}

export const ThreadDelete = (thread: ICharThread) => {
    fetch(apiAddress + "/char/threads/", createOptions('DELETE', thread))
        .then((res) => res.json())
        .then((data) => console.log('BEThread delete repsonse', data))
        .catch((reason => console.log('BEThread delete catch', reason)))
}

export const ThreadStepsGet = (cid: string) => {
    fetch(apiAddress + "/char/threadsteps/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                if (data.hasOwnProperty('result')) {
                    console.log('BEThreadSteps get reponse', data.result);
                    s_char_threadsteps.value = (data.result as ICharThreadStep[])
                }
            }
        )
        .catch((reason => {
            console.log('BEThreadSteps get catch', reason);
        }))
}

export const ThreadStepCreate = (threadstep: ICharThreadStep) => {
    fetch(apiAddress + "/char/threadsteps/", createOptions('CREATE', threadstep))
        .then((res) => res.json())
        .then((data) => console.log('BEThreadStep create reponse', data))
        .catch((reason => console.log('BEThreadStep create catch', reason)))
}

export const ThreadStepUpdate = (threadstep: ICharThreadStep) => {
    fetch(apiAddress + "/char/threadsteps/", createOptions('UPDATE', threadstep))
        .then((res) => res.json())
        .then((data) => console.log('BEThreadStep update repsonse', data))
        .catch((reason => console.log('BEThreadStep update catch', reason)))
}

export const ThreadStepDelete = (threadstep: ICharThreadStep) => {
    fetch(apiAddress + "/char/threadsteps/", createOptions('DELETE', threadstep))
        .then((res) => res.json())
        .then((data) => console.log('BEThreadStep delete repsonse', data))
        .catch((reason => console.log('BEThreadStep delete catch', reason)))
}